/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/user_feedback'
export default icon
